module.exports = __webpack_public_path__ + "assets/img/home-logo3.62e792c8.png";